
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Downloads } from "@components/downloads";
import { NextSeo } from "@components/seo";
import parse from "html-react-parser";
import type { GetStaticProps, NextPage } from "next/types";
import { PAGE } from "../consts/ppages";
import { getPageById } from "../utils/get-page";
interface IPage {
    page: {
        title: string;
        content: string;
        downloads: {
            downloads: {
                name: string;
                icon: {
                    sourceUrl: string;
                };
                file: {
                    mediaItemUrl: string;
                };
            }[];
        };
    };
}
const Certificates: NextPage<IPage> = ({ page }) => (<>
    <NextSeo languageAlternates={[
        { href: "https://knsokna.pl/certificates", hrefLang: "x-default" },
        { href: "https://knswindows.com/certificates", hrefLang: "en" },
        { href: "https://knsokna.pl/certificates", hrefLang: "pl" },
        { href: "https://knsfenster.de/certificates", hrefLang: "de" },
        { href: "https://kns-okna.eu/certificates", hrefLang: "cs" },
        { href: "https://knsfinestre.it/certificates", hrefLang: "it" },
        { href: "https://knsfenetres.fr/certificates", hrefLang: "fr" },
        { href: "https://knsokna.eu/certificates", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div>{parse(page?.content || "")}</div>
        <Downloads downloads={page?.downloads}/>
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PAGE_ID = PAGE.CERTIFICATES[LOCALE as keyof typeof PAGE.CERTIFICATES] || 1;
    const { page } = await getPageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default Certificates;

    async function __Next_Translate__getStaticProps__1a1a83a9425__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/certificates',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1a83a9425__ as getStaticProps }
  